/**
 * @file Account related queries for Web Galleries.
 */

import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../fragments/global';

export const AccountForWebGalleries = gql`
  query accountForWebGalleries {
    me {
      id
      email_address
      email_verified
      username
      name
      phone_number
      organization_name
      addresses {
        id
        name
        address_line_1
        address_line_2
        city
        state
        post_code
        country {
          id
          name
        }
        soft_deleted
      }
      linked_identities {
        total
        records {
          id
          name
          last_name
          relationship
          current_photo {
            id
            thumbnail_urls {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export const AccountWithAlbumMemberships = gql`
  query accountWithAlbumMemberships {
    me {
      id
      album_memberships(slice: { limit: 9999 }, with_paid: true) {
        records {
          id
          album {
            id
          }
        }
      }
    }
  }
`;

export const AccountPurchases = gql`
  query accountPurchases {
    me {
      id
      album_memberships(with_paid: true, slice: { limit: 9999 }) {
        records {
          id
          album {
            id
          }
          purchased_identities {
            records {
              id
            }
          }
        }
      }
    }
  }
`;
